import { render, staticRenderFns } from "./suspendedModal.vue?vue&type=template&id=aaa77a98&"
import script from "./suspendedModal.vue?vue&type=script&lang=js&"
export * from "./suspendedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports